import { usePost } from '../../HttpClient';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useCreateTransactionReason() {
  const post = usePost(true, "tms");
  const createTransactionReason = (request: any) =>
    post<{ id: string }>(`${referenceDataBaseUrl}/transaction-reasons`, request);

  return useMutationWithErrorHandling({
    mutationFn: async (request: any) => await createTransactionReason(request),
  });
}
